export interface DataRetentionRuleInterface {
  id: number;
  all_offices: boolean;
  data_retention_days: number;
  data_to_be_deleted: Array<string>;
  days_of_week: Array<number>;
  emails: Array<string>;
  enabled: boolean;
  office_ids: Array<number>;
  organization_id: number;
  selected_users: Array<{
    value: number;
    label: string;
  }>;
  time: string | null | undefined;
  time_zone: string | null | undefined;
}

export class DataRetentionRule implements DataRetentionRuleInterface {
  id: number;
  all_offices: boolean;
  data_retention_days: number;
  data_to_be_deleted: Array<string>;
  days_of_week: Array<number>;
  emails: Array<string>;
  enabled: boolean;
  office_ids: Array<number>;
  organization_id: number;
  selected_users: Array<{
    value: number;
    label: string;
  }>;
  time: string | null | undefined;
  time_zone: string | null | undefined;

  constructor(props: any = {}) {
    this.id = props.id;
    this.all_offices = props.all_offices;
    this.data_retention_days = props.data_retention_days || 0;
    this.data_to_be_deleted = props.data_to_be_deleted;
    this.days_of_week = props.days_of_week || [];
    this.enabled = props.enabled;
    this.emails = props.emails || [];
    this.office_ids = props.office_ids || [];
    this.organization_id = props.organization_id;
    this.selected_users = props.selected_users || [];
    this.time = props.time;
    this.time_zone = props.time_zone;
  }
}
